export const SET_ROADMAP_PROGRESS = "SET_ROADMAP_PROGRESS";
export const RESET_ROADMAP_PROGRESS = "RESET_ROADMAP_PROGRESS";

export const setRoadmapProgress = (step, answers) => ({
  type: SET_ROADMAP_PROGRESS,
  payload: { step, answers},
});

export const resetRoadmapProgress = () => ({
  type: RESET_ROADMAP_PROGRESS,
});
